module.exports = __webpack_public_path__ + "img/logo_nrmemories.136015a7.png";